var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "21px",
    viewBox: "0 0 17 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "notification"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,0 C7.62181,0 6.90908,0.7056 6.90908,1.575 L6.90908,2.30508 C4.16547,3.0052 2.13633,5.46504 2.13633,8.4 L2.13633,13.65 L14.8637,13.65 L14.8637,8.4 C14.8637,5.46504 12.8345,3.0052 10.0909,2.30508 L10.0909,1.575 C10.0909,0.7056 9.37819,0 8.5,0 Z M1.07572,15.75 C0.935174,15.748 0.795637,15.7737 0.665215,15.8256 C0.534794,15.8775 0.416089,15.9545 0.315999,16.0522 C0.21591,16.1499 0.136431,16.2663 0.0821834,16.3947 C0.0279355,16.5231 0,16.6608 0,16.8 C0,16.9391 0.0279355,17.0769 0.0821834,17.2053 C0.136431,17.3337 0.21591,17.4501 0.315999,17.5478 C0.416089,17.6455 0.534794,17.7225 0.665215,17.7744 C0.795637,17.8263 0.935174,17.852 1.07572,17.85 L6.66464,17.85 C6.47788,18.1691 6.37929,18.5312 6.37878,18.9 C6.37878,19.457 6.60226,19.9911 7.00007,20.3849 C7.39788,20.7787 7.93742,21 8.5,21 C9.06258,21 9.60213,20.7787 9.99993,20.3849 C10.3977,19.9911 10.6212,19.457 10.6212,18.9 C10.6201,18.531 10.5208,18.1689 10.3333,17.85 L15.9243,17.85 C16.0648,17.852 16.2044,17.8263 16.3348,17.7744 C16.4652,17.7225 16.5839,17.6455 16.684,17.5478 C16.7841,17.4501 16.8636,17.3337 16.9178,17.2053 C16.9721,17.0769 17,16.9391 17,16.8 C17,16.6608 16.9721,16.5231 16.9178,16.3947 C16.8636,16.2663 16.7841,16.1499 16.684,16.0522 C16.5839,15.9545 16.4652,15.8775 16.3348,15.8256 C16.2044,15.7737 16.0648,15.748 15.9243,15.75 L1.07572,15.75 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationWhite);
export default __webpack_public_path__ + "static/media/notificationWhite.8e1e1a13c7456f68c6ad7c33347ffbb6.svg";
export { ForwardRef as ReactComponent };